import { Col, Container, Form, Row } from "react-bootstrap";
import ZustandProductCgi from "../../Zustand/ZustandProductCgi";
import GenerateQuestion from "../GenereteQuestion/GeneratQuestion";
import useStore from "../../Zustand/Zustand";
import ZustandDadosDeFinanciamento from "../../Zustand/ZustandDadosDeFinanciamento";

const SelectCgiOrFin = () => {
  const { setCgi, cgi } = ZustandProductCgi();
  const { simulacoes, resetSimulacoes} = useStore();
  const {setTaxaInter,  setTaxaBrb,  setTaxaSantander, setTaxaItau, setTaxaCaixa, setTaxaBradesco} = ZustandDadosDeFinanciamento()


  const handleChangeSelectBank = (event) => {
      setCgi(event.target.value);
      resetSimulacoes()
      setTaxaInter(0)  
      setTaxaBrb(0)
      setTaxaSantander(0)
      setTaxaItau(0)
      setTaxaCaixa(0)
      setTaxaBradesco(0)
  };

  return (
    <Container className="custom-margin-left mt-5 p-0 mb-2" fluid>
      <Row className="d-flex align-items-start flex-wrap">
        <Col
          xs={12}
          lg={3}
          className="d-flex justify-content-center align-items-center p-0 px-4 px-md-0"
        >
          <GenerateQuestion
            header="Deseja selecionar qual tipo de produto?"
            subheader="Com isso, você pode escolher o FIN (Financimento Imobiliario) ou CGI (Crédito de garantia de ímovel)."
          />
        </Col>
        <Col xs={1} sm={1} md={1} lg={1}></Col>
        <Col className=" me-xl-5 mx-2 ">
          <Col xs={12} md={6} lg={9} className="mb-3">
            <Form.Label className="label">
              Produto
              <Col xs={10} sm={6} md={5} lg={9} xl={7}>
                <Form.Select value={cgi} onChange={handleChangeSelectBank}>
                  <option value="FIN">Financiamento Imobiliário</option>
                  <option value="CGI">Crédito com Garantia de Imóvel</option>
                </Form.Select>
              </Col>
            </Form.Label>
          </Col>
        </Col>
      </Row>
    </Container>
  );
};

export default SelectCgiOrFin;
